export default {"src":"/_next/static/media/no-email.4afb13ff.svg","height":314,"width":314,"blurWidth":0,"blurHeight":0};